export default __webpack_public_path__ + "static/media/g2022-23.464df23b.jpeg";